import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import BattleWizard from 'components/BattleWizard/BattleWizard.jsx'
import LoadingScreen from 'components/LoadingScreen/LoadingScreen.jsx'

import { FEATURE_TYPES } from 'constants'
import { isFeatureAvailable } from 'helpers/accounts'
import { formatMessage } from 'locale'

import WINDOW_TITLES from 'window_titles'
import rebuildUnit from 'state/actions/unit_rebuild'
import requestUnitRebuildInfo, { closeWindow } from 'state/actions/unit_rebuild_info'

export class UnitRebuildWizard extends React.Component {
    static propTypes = {
        clanIndustrialResource: PropTypes.number,
        loaded: PropTypes.bool.isRequired,
        loading: PropTypes.bool.isRequired,
        fortBattles: PropTypes.object.isRequired,
        sorties: PropTypes.object.isRequired,
        peripheryId: PropTypes.number.isRequired,
        expiresAt: PropTypes.number,
        unitServerId: PropTypes.number.isRequired,
        unitInfo: PropTypes.object.isRequired,
        showOldSchedule: PropTypes.bool,
        industrialResourceMultiplier: PropTypes.number.isRequired,

        rebuildUnit: PropTypes.func.isRequired,
        requestUnitRebuildInfo: PropTypes.func.isRequired,
        closeWindow: PropTypes.func.isRequired,
    }

    componentWillMount() {
        document.title = formatMessage(WINDOW_TITLES.wizard_rebuild)
        this.props.requestUnitRebuildInfo(this.props.unitServerId)
    }

    render() {
        if (!this.props.loaded || this.props.loading) {
            return <LoadingScreen type='window' />
        }

        const { unitServerId } = this.props
        const rebuildUnit = this.props.rebuildUnit.bind(null, unitServerId)
        const requestUnitRebuildInfo = this.props.requestUnitRebuildInfo.bind(null, unitServerId)
        return (
            <BattleWizard
                clanIndustrialResource={this.props.clanIndustrialResource}
                loaded={this.props.loaded}
                loading={this.props.loading}
                fortBattles={this.props.fortBattles}
                sorties={this.props.sorties}
                peripheryId={this.props.peripheryId}
                expiresAt={this.props.expiresAt}
                submit={rebuildUnit}
                requestInfo={requestUnitRebuildInfo}
                unitInfo={this.props.unitInfo}
                closeWindow={this.props.closeWindow}
                isRebuild
                showSchedule={this.props.showOldSchedule}
                industrialResourceMultiplier={this.props.industrialResourceMultiplier}
            />
        )
    }
}

export const mapStateToProps = ({ account, clan, unitRebuildInfo, settings }, ownProps) => {
    const { periphery_id: peripheryId } = account
    const {
        loading,
        loaded,
        fort_battles: fortBattles,
        sorties,
        expiresAt,
        unit_info: unitInfo,
    } = unitRebuildInfo
    const { industrialResourceMultiplier } = settings

    const unitServerId = parseInt(ownProps.params.unitServerId)
    const clanIndustrialResource = clan ? clan.industrial_resource : null

    return {
        clanIndustrialResource,
        loading,
        loaded,
        fortBattles,
        sorties,
        peripheryId,
        expiresAt,
        unitServerId,
        unitInfo,
        showOldSchedule: !isFeatureAvailable(account, FEATURE_TYPES.SCHEDULE),
        industrialResourceMultiplier,
    }
}

export const mapDispatchToProps = {
    rebuildUnit,
    requestUnitRebuildInfo,
    closeWindow,
}

export default connect(mapStateToProps, mapDispatchToProps)(UnitRebuildWizard)



// WEBPACK FOOTER //
// ./containers/UnitRebuildWizard/UnitRebuildWizard.jsx